import { render, staticRenderFns } from "./SettingsTitle.vue?vue&type=template&id=7840d31c&scoped=true&"
import script from "./SettingsTitle.vue?vue&type=script&lang=js&"
export * from "./SettingsTitle.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTitle.vue?vue&type=style&index=0&id=7840d31c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7840d31c",
  null
  
)

export default component.exports